import type { CountryConfig } from "@orvis/core";
import { ADMOB_CN } from "../ads.js";
import { defaultDarkTheme } from "../theme.js";

/**
 * China config.
 *   - Firestore collection: `cn` (legacy/frontend/com.mlopezitsolutions.chinatv/app/services/db.service.ts)
 *   - Play Store id:       com.mlopezitsolutions.chinatv
 *   - Play Store listing is Chinese (zh-CN) — the app UI matches that by
 *     defaulting to the `cn` locale catalog. News headlines stay in
 *     English regardless: the feeds below are English-language China
 *     coverage (no reliable Chinese-language RSS source was available —
 *     see the dead-feed notes on the legacy sources), so that's a content
 *     gap, not a UI string gap.
 */
export const cn: CountryConfig = {
  code: "cn",
  name: "China",
  flag: "🇨🇳",
  defaultLocale: "cn",
  bundleId: "com.mlopezitsolutions.chinatv",
  newsSources: [
    {
      id: "cgtn-china",
      name: "CGTN — China",
      feedUrl: "https://www.cgtn.com/subscribe/rss/section/china.xml",
      kind: "rss",
      language: "en",
      homepage: "https://www.cgtn.com/",
      enabled: true,
      category: "general",
      liveChannel: "CGTN",
    },
    {
      id: "cgtn-world",
      name: "CGTN — World",
      feedUrl: "https://www.cgtn.com/subscribe/rss/section/world.xml",
      kind: "rss",
      language: "en",
      homepage: "https://www.cgtn.com/",
      enabled: true,
      category: "general",
      liveChannel: "CGTN",
    },
    {
      id: "ecns",
      name: "ECNS",
      feedUrl: "http://www.ecns.cn/rss/rss.xml",
      kind: "rss",
      language: "en",
      homepage: "https://www.ecns.cn/",
      enabled: true,
      category: "general",
    },
    // Note: english.news.cn/rss/index.xml returned 404 as of 2026-09 —
    // dropped here and from newsUpdaters.js's FEEDS. CCTV's RSS endpoints
    // (both cctv.com and english.cctv.cn) are also dead: frozen with no
    // items newer than 2010/2007. ECNS (China News Service) above fills
    // the gap with a live English-language feed.
  ],
  ads: {
    publisherId: ADMOB_CN.publisherId,
    bannerUnitId: ADMOB_CN.banner,
    interstitialUnitId: ADMOB_CN.interstitialPlayChannel,
    appOpenUnitId: ADMOB_CN.appOpen,
  },
  theme: defaultDarkTheme,
};
